/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function n(n){return n}export{n as createContext};
//# sourceMappingURL=create-context.js.map
